module.exports = __webpack_public_path__ + "static/media/flute.6d3f58c7.m4a";